export const call = {
  status: {
    answered: 'Отвечено',
    busy: 'Занято',
    no_answer: 'Без ответа',
    failed: 'Ошибка'
  },

  type: {
    outgoing: 'Исходящий',
    incoming: 'Входящий'
  }
};
